import { render, staticRenderFns } from "./Paymentsuccessful.vue?vue&type=template&id=5884831e&scoped=true"
import script from "./Paymentsuccessful.vue?vue&type=script&lang=js"
export * from "./Paymentsuccessful.vue?vue&type=script&lang=js"
import style0 from "./Paymentsuccessful.vue?vue&type=style&index=0&id=5884831e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5884831e",
  null
  
)

export default component.exports